import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../pages/main.vue'
import Init from '../pages/init.vue'
import Home from '../pages/home.vue'
import Support from '../pages/support.vue'
import Contact from '../pages/contact.vue'
import Product from '../pages/product.vue'
import Application from '../pages/application.vue'
import VideoGallery from '../pages/videoGallery.vue'
Vue.use(VueRouter)


//解决vue-router3.0重复访问同一路由导致的报错问题
let originalPush = VueRouter.prototype.push
let originalReplace  = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location){
    return originalPush.call(this,location).catch(e=>e)
}
VueRouter.prototype.replace = function push(location){
    return originalReplace.call(this,location).catch(e=>e)
}
const router= new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/main/home'
        },

        {
            path: '/main',
            name: 'main',
            component: Main,
            redirect: '/main/home',
            children: [
                {
                    path: 'home',
                    name: 'home',
                    component: Home
                },
                {
                    path: 'support',
                    name: 'support',
                    component: Support
                },
                {
                    path: 'contact',
                    name: 'contact',
                    component: Contact
                },
                {
                    path: 'product/:id',
                    name: 'product',
                    component: Product
                },
                {
                    path: 'application',
                    name: 'application',
                    component: Application
                },
                {
                    path: 'videoGallery',
                    name: 'videoGallery',
                    component: VideoGallery
                },
            ]
        }
    ]
})

const whiteList = [] //路由白名单
router.beforeEach(async(to, from, next) => {
    for(let i = 0;i<whiteList.length;i++){
        if(to.path.indexOf(whiteList[i])>-1){
            next()
            return
        }
    }
    next()

})
export default router;
